import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { StyledLabel } from 'elements/Label/Label';
import { FormInput } from 'elements/Inputs/FormInput/';
import { FormDropdown } from 'elements/Inputs/FormInput/Dropdown/Dropdown';
import { selectFullPartialStrokeTestSection } from './FullPartialStrokeTest.data';
import { StyleDropdown } from '../AsFoundTestTableSection/AsFoundTestSection.styled';

const useStyles = formName => makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    }
}));

const FullPartialStrokeTest = (props) => {
    const { selectedTag, changeHandler, formData, formName, isFormReadOnly, userRole, multiTRFDetails } = props;
    const classes = useStyles(formName)();
    const styleFormInput = (field) => field.isLabel ? (
        <StyledLabel
            id={field.key}
            fontWeight={field.fontWeight}
            textAlign={field.textAlign}
            labelWidth={field.labelWidth}
            padding={field.padding}
            marginLeft={field.marginLeft}
            fontSize={field.fontSize}
            color={field.color}
        >
            {field.label}
        </StyledLabel>
    )
        : (
            <FormInput
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                isRequired={field.isRequired}
                isCalculatedNew={field.isCalculatedNew}
                handleChange={changeHandler}
                readOnly={field.readOnly || isFormReadOnly}
                labelWidth={field.labelWidth}
                width={field.width}
                marginRight={field.marginRight}
                marginLeft={field.marginLeft}
                marginTop={field.marginTop}
                direction={field.direction}
                padding={field.padding}
                type={field.type}
                maxLength={field.maxLength}
                height={field.height}
                textAlign={field.textAlign}
            />
        );
    return (
        <Grid container spacing={1} className={classes.root}>
            {
                selectFullPartialStrokeTestSection(selectedTag, formName, formData, multiTRFDetails).rows.map(row => (
                    <Grid item container xs={12} key={row.key} style={{ paddingBottom: '0', paddingTop: '0' }}>
                        {row.fields.map(field => (
                            <Grid item xs={field.xs} key={field.key}>
                                {field.isDropdown
                                    ? (
                                        <StyleDropdown
                                            formName={formName}
                                        >
                                            <FormDropdown
                                                id={field.key}
                                                name={field.key}
                                                label={field.label}
                                                value={field.value}
                                                placeholder={field.placeholder}
                                                handleChange={changeHandler}
                                                options={field.options}
                                                isRequired={field.isRequired}
                                                labelWidth={field.labelWidth}
                                                width={field.width}
                                                readOnly={isFormReadOnly}
                                                direction={field.direction}
                                                padding={field.padding}
                                                height={field.height}
                                                userRole={userRole}
                                                marginTop={field.marginTop}
                                                inputTextAlign={field.inputTextAlign}
                                                marginBottom={field.marginBottom}
                                            />
                                        </StyleDropdown>
                                    )
                                    : styleFormInput(field)}
                            </Grid>
                        )
                        )}
                    </Grid>
                ))
            }
        </Grid>
    );
};

const mapStateToProps = ({ TagSelectionMOScreen, Forms, Home }) => ({
    selectedTag: Forms.selectedTag,
    userRole: Home.userRole,
    multiTRFDetails: Forms.multiTRFDetails,
});
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FullPartialStrokeTest);

FullPartialStrokeTest.propTypes = {
    changeHandler: PropTypes.func,
    formData: PropTypes.object,
    formName: PropTypes.string,
    isFormReadOnly: PropTypes.bool,
    multiTRFDetails: PropTypes.array,
    selectedTag: PropTypes.object,
    userRole: PropTypes.string,
};
